import React from "react";
import NO_AVA from "styles/img/no-ava-card.png";
import Cpd_Cert from "styles/img/cpd_cert_ico.svg";
import classNames from "classnames";
import { Link } from "react-router-dom";
const GENERATE_SERTIFICATE = '/api/v1/pdfs/generate_certificate';

export default class TraineeItem extends React.Component {

  generateSertificate = () => {
    const url = `${GENERATE_SERTIFICATE}?workshop_id=${this.props.data.workshop.id}`;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    fetch(url, init)
    .then(resp => {
      if(resp.status=='200'){
      resp.blob()
      .then( file => {
      let objUrl = window.URL.createObjectURL(file)
        window.open(objUrl)
    })
    }
    else {
      alert("Something went wrong. Please check your connection or try again later")
    }
    })
  }

  render() {
    let type = this.props.data.status;
    return (
      <div className="col-12">
        <div
          className={classNames("card regular purchases", {
            progress: type === "workshop_trainee_progress",
            completed: type === "workshop_completed"
          })}
        >
          <div className="purchases-content">
            <div className="card-top-wrap">
              <div className="card-head-avatar-holder">
                <div className="card-head-avatar">
                  {this.props.data.user.avatar_url ? (
                    <img src={this.props.data.user.avatar_url} alt="avatar" />
                  ) : (
                      <img src={NO_AVA} alt="avatar" />
                    )}
                </div>
                <div className="card-head-name-holder">
                  <span className="card-head-title">TRAINEE</span>
                  <span className="card-head-name">
                    {this.props.data.user.full_name}
                  </span>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="card-footer-top">
                <p className="card-title">{this.props.data.workshop.title}</p>
              </div>
              <div className="card-footer-bottom">
                <span className="btn grey-empty empty bordered purchases-btn hide-m hide-l hide-xl">
                  TRAINEE PROGRESS
                </span>
              </div>
            </div>
          </div>
          <div className="purchases-price">
            <p className="caption">sold:</p>
            <p className="date">{this.props.data.responce_time}</p>
            {type === "workshop_trainee_progress" && (
              <Link
                to={`/provider/checkresponces/${this.props.data.workshop.id}/${
                  this.props.data.user.id
                  }`}
              >
                <span className="btn grey-empty empty bordered purchases-btn hide-s hide-xs">
                  TRAINEE PROGRESS
                </span>
              </Link>
            )}
            {type === "workshop_check_response" && (
              <Link
                to={`/provider/checkresponces/${this.props.data.workshop.id}/${
                  this.props.data.user.id
                  }`}
              >
                <span className="btn prime bordered purchases-btn hide-s hide-xs">
                  CHECK RESPONSES
                </span>
              </Link>
            )}
            {type === "workshop_completed" && (
              <Link
                to={`/provider/checkresponces/${this.props.data.workshop.id}/${
                  this.props.data.user.id
                  }`}
              >
                <span className="btn green empty bordered purchases-btn hide-s hide-xs">
                  COMPLETED
                </span>
              </Link>
            )}
            {/* TODO START: - add some additional key to check with */}
            {type === "workshop_completed" && (
              <div className="cpd-cert-container">
                <div className="cpd-text-wrapper">
                  <p>cpd certificate</p>
                  <p>generated</p>
                </div>
                <img src={Cpd_Cert} alt="cert" />
              </div>
            )}
            {/* TODO END */}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/trainee_responces/TraineeItem.jsx